module.exports = __webpack_public_path__ + "img/6.e925f644.svg";